import { render } from "./LinksInfo.vue?vue&type=template&id=54af1b78&scoped=true"
import script from "./LinksInfo.vue?vue&type=script&lang=js"
export * from "./LinksInfo.vue?vue&type=script&lang=js"

import "./LinksInfo.vue?vue&type=style&index=0&id=54af1b78&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-54af1b78"]])

export default __exports__